module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-BookItalic.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-BookItalic.woff
 ** module id = 1098
 ** module chunks = 0
 **/